import React from 'react'
import Others from '../Reusable/Others'

const Othersoption = () => {
  return (
    <div className='flex lg:flex-row flex-col gap-4 w-full lg:justify-around pb-16 pt-5 lg:pl-0 pl-[10%] border-t-2 border-white'>
        <Others
            image={"/Blockfarm/callsupport.svg"}
            style={"lg:text-[28px] text-[14px] font-semibold text-white"}
            title={"Call Support"}
            content={"Online Support 24/7"}
        />
        <Others
            image={"/Blockfarm/guarantee.svg"}
            style={"lg:text-[28px] text-[14px] font-semibold text-white"}
            title={"Guarantee"}
            content={"Money Back Guarantee"}
        />
        <Others
            image={"/Blockfarm/specialgift.svg"}
            style={"lg:text-[28px] text-[14px] font-semibold text-[#4E9AE1]"}
            title={"Special Gifts"}
            content={"Receive special gifts"}
        />
        <Others
            image={"/Blockfarm/shipping.svg"}
            style={"lg:text-[28px] text-[14px] font-semibold text-white"}
            title={"Shipping"}
            content={"Worldwide shipping upto $99"}
        />
    </div>  
  )
}

export default Othersoption